import { deleteCookie, getCookie, setCookie } from '@helpers/cookie';
import {
  FORWARD_LOGIN_FAIL,
  FORWARD_LOGIN_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_ACTION,
  SET_ACTIVE_PROFILE,
  SET_AGENT_INFO,
  SET_TOKEN_LOGIN,
  SET_ROLES_AFTER_ACTIVE_PROFILE,
  SET_ALL_PROFILES_ROLES,
  SET_PERSONAL_DETAIL_INFORMATION,
  SET_BUSINESS_INFORMATION,
  SET_IS_HOUSEHOLD,
  SET_FORGET_PASSWORD_FACTORS,
  SET_OTP_FORGET_PASSWORD,
} from './constants';
import { COOKIE_NAME, TOKEN } from '@helpers/constants';

const _token = getCookie(TOKEN.SP_ACCESS_TOKEN);
const _activeProfile = getCookie(COOKIE_NAME.ACTIVE_PROFILE);

const initialState = {
  roles: [],
  allProfilesRoles: [],
  forwardLogin: false,
  token: _token || '',
  isLogin: false,
  activeProfile: _activeProfile || '',
  agentInfo: {},
  personalDetailInfo: {},
  businessInfo: {},
  isHouseHold: false,
  forgetPasswordFactors: [],
  otpForgetPassword: {},
};

const authReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_REQUEST:
      state = {
        ...state,
        isLogin: false,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        isLogin: true,
      };
      break;
    case SET_TOKEN_LOGIN:
      setCookie(TOKEN.SP_ACCESS_TOKEN, payload, 86400000);
      state = {
        ...state,
        token: payload,
        forwardLogin: true,
        isLogin: true,
      };
      break;
    case LOGOUT_ACTION:
      deleteCookie(TOKEN.SP_ACCESS_TOKEN);
      state = {
        ...state,
        token: '',
        isLogin: false,
        loading: false,
      };
      break;
    case SET_ACTIVE_PROFILE:
      {
        let activeProfile = '';
        if (getCookie(COOKIE_NAME.ACTIVE_PROFILE)) {
          activeProfile = getCookie(COOKIE_NAME.ACTIVE_PROFILE);
        } else {
          activeProfile = payload.profiles[0].code;
          setCookie(COOKIE_NAME.ACTIVE_PROFILE, activeProfile, 86400000);
        }
        let roles = [];
        for (const profile of payload.profiles) {
          if (
            profile.roles &&
            profile.roles.length > 0 &&
            profile.code === activeProfile
          ) {
            roles = profile.roles;
          }
        }
        const allProfilesRoles = payload.profiles.flatMap((p) => p.roles || []);
        state = {
          ...state,
          activeProfile,
          roles,
          allProfilesRoles,
        };
      }
      break;
    case SET_AGENT_INFO:
      state = {
        ...state,
        agentInfo: payload,
      };
      break;
    case FORWARD_LOGIN_SUCCESS:
      state = {
        ...state,
        forwardLogin: true,
      };
      break;
    case FORWARD_LOGIN_FAIL:
      state = {
        ...state,
        forwardLogin: false,
      };
      break;
    case SET_ROLES_AFTER_ACTIVE_PROFILE:
      state = {
        ...state,
        roles: payload,
      };
      break;
    case SET_ALL_PROFILES_ROLES:
      state = {
        ...state,
        allProfilesRoles: payload,
      };
      break;
    case SET_PERSONAL_DETAIL_INFORMATION:
      state = {
        ...state,
        personalDetailInfo: payload,
      };
      break;
    case SET_BUSINESS_INFORMATION:
      state = {
        ...state,
        businessInfo: payload,
      };
      break;
    case SET_IS_HOUSEHOLD:
      state = {
        ...state,
        isHouseHold: payload,
      };
      break;
    case SET_FORGET_PASSWORD_FACTORS:
      state = {
        ...state,
        forgetPasswordFactors: payload,
      };
      break;
    case SET_OTP_FORGET_PASSWORD:
      state = {
        ...state,
        otpForgetPassword: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default authReducers;
